import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory, useLocation,
  BrowserRouter as Router, useParams,
} from 'react-router-dom';
import { Button } from 'react-scroll';
import {
  setCidade, getIdCidadeEcrie, setAuthToken, setTotem, getTotem,
} from '../../api/apiFactory';
import {
  fetchCidades, fetchLimparCookie,
  fetchNomeCidade, fetchSecretarias, fetchConfiguracoes, fetchVerificarStatusCidade, fetchCarregarSolicitante,
} from '../../api/endpoints';
import {
  definirCidade, fetchConfiguracoesCidade, selectCidade, desfazerCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  abrirModalAjuda, abrirModalLoginManifestacao, abrirModalTotemEscolhaLoginManifestacao, abrirModalTotemLoginManifestacao, resetarModais, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, selectSecretaria, desfazerSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import GridBotao from '../../components/GridBotao/GridBotao';
import ModalEscolhaLoginTotem from '../../components/ModalEscolhaLoginTotem/ModalEscolhaLoginTotem';
import ModalLoginTotem from '../../components/ModalLoginTotem/ModalLoginTotem';
import {
  Alerta, AppBody, AppBodyTotem, AppFragment, BreadCumbs, CampoForm,
  Container, ContainerSelecao, ContainerTotem, Divisor, Grid, GridTotem, Linha, Titulo,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { isCorClara } from '../../util/color';
import { replaceDiacritico } from '../../util/stringFactory';

const defaulValues = {
  BuscaCidade: '',
  IdEstado: '',
  NomeEstado: '',
};

const SelecionarOpcaoSic = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);
  const dadosSecretaria = useSelector(selectSecretaria);
  const dadosModal = useSelector(selectModal);
  const [nomeUsuario, setNomeUsuario] = useState('');

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const cookieSelecionado2 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeCrie')) : null;
  const cookieSelecionadoSeparado2 = cookieSelecionado2 ? cookieSelecionado2.split('=') : null;
  const cookieIdEcrie = cookieSelecionadoSeparado2
    ? cookieSelecionadoSeparado2[cookieSelecionadoSeparado2.length - 1]
    : null;

  window.onload = () => {
    dispatch(resetarModais());
  };

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const formataNome = (nomes) => {
    const words = nomes.length > 0 && nomes.toLowerCase().split(' ');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words && words.join(' ');
  };

  const iniciarAcompanhamento = () => {
    if (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N' && !(dadosLogin && dadosLogin.data)) {
      history.push('/totem/sic/acompanhamento/login');
      return;
    }

    if (dadosLogin.data) {
      history.push('/totem/sic/acompanhamento');
    } else {
      history.push('/totem/sic/acompanhamento/escolhalogin');
    }
  };

  const iniciarCadastro = () => {
    if (dadosLogin.data) {
      history.push('/totem/sic/cadastrar');
    } else {
      history.push('/totem/sic/cadastrar/escolhalogin');
    }
  };

  useEffect(() => {
    if (getTotem() === 'true') {
      setTimeout(() => {
        document.querySelector('body').click();
        document.querySelector('body').focus();
        document.querySelector('body').click();
      }, 2000);
    }
    if (getTotem() !== 'true') history.push('/');
    fetchCarregarSolicitante().then((dados) => setNomeUsuario(dados.Solicitante));
  }, []);

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      <BreadCumbs>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            Você está em:
            {' '}
            <span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>
          </div>
          {dadosLogin && dadosLogin.data && (
            <div>
              <span style={{ textAlign: 'right' }}>Logado como: </span>
              <span style={{ fontWeight: 'bold', textAlign: 'right' }}>{formataNome(nomeUsuario)}</span>
            </div>
          )}
        </div>
      </BreadCumbs>
      <ContainerTotem>
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => history.push('/totem')}
        />
        {(dadosLogin && dadosLogin.data) && (
        <Botao
          sair
          label="Sair"
          style={{ marginRight: espacamento.pequeno }}
          onClick={() => {
            dispatch(desfazerConexao());
            dispatch(desfazerSecretaria());
            limpaLoginAnonimo(dadosLogin);
            history.push('/totem');
          }}
        />
        )}
        <GridTotem totem>
          <GridBotao
            onClick={() => iniciarAcompanhamento()}
            totem
            selecao
            key="Acompanhar"
            label="Acompanhar meu pedido"
            img="https://eouve.com.br/svg_icons/dark/acompanhar_.svg"
            size={14}
            imgWidth={50}
            imgHeight={50}
            cor="#7bc8a4"
          />
          <GridBotao
            totem
            selecao
            onClick={() => iniciarCadastro()}
            key="Cadastrar"
            label="Cadastrar um novo pedido"
            img="https://eouve.com.br/svg_icons/dark/chat_Prancheta_1.svg"
            size={20}
            imgWidth={50}
            imgHeight={50}
            cor="#fec65f"
          />
        </GridTotem>
      </ContainerTotem>
    </AppFragment>
  );
};

export default SelecionarOpcaoSic;
